import { render, staticRenderFns } from "./Newsletter-Details.vue?vue&type=template&id=7d8a55b8&scoped=true&"
import script from "./Newsletter-Details.vue?vue&type=script&lang=js&"
export * from "./Newsletter-Details.vue?vue&type=script&lang=js&"
import style0 from "./Newsletter-Details.vue?vue&type=style&index=0&id=7d8a55b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8a55b8",
  null
  
)

export default component.exports